import { render, staticRenderFns } from "./UserReviewModal.vue?vue&type=template&id=c5681f3a&scoped=true"
import script from "./UserReviewModal.vue?vue&type=script&lang=js"
export * from "./UserReviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5681f3a",
  null
  
)

export default component.exports